import React from 'react'

//UI
import { Badge, Flex, HStack, Heading, Text, VStack } from '@chakra-ui/react'
import { camelToWords } from '@/utils/stringHelper'

//Hooks
import { useTranslation } from 'react-i18next'
import { VendorUploadStatus } from '@/features/vendors/constants'

// Types
const VendorUploadQuotationPageHeader = ({ RFQDetail, lastRequestType }) => {
  const { t } = useTranslation()

  return (
    <Flex p={5} borderBottom="1px solid #d8dbe0" justifyContent={'space-between'}>
      <Flex direction={'column'}>
        <Heading>
          {RFQDetail?.RFQCode}
          {RFQDetail?.scopeOfSupply !== '' ? ` - ${RFQDetail?.scopeOfSupply}` : ''}
        </Heading>
        <Heading size={'lg'}>{camelToWords(lastRequestType)}</Heading>
        {RFQDetail?.status && RFQDetail?.status !== '' && (
          <HStack>
            <Badge colorScheme="teal">{t('VENDOR_UPLOAD_PAGE_COST_BUDGET_TYPE_' + RFQDetail?.costBudgetType)}</Badge>
            <Badge colorScheme={RFQDetail?.status === VendorUploadStatus.REJECTED ? 'red' : 'gray'}>
              {t('VENDOR_UPLOAD_STATUS_' + RFQDetail?.status.toUpperCase())}
            </Badge>
          </HStack>
        )}
        {RFQDetail?.isExpired && (
          <Text color={'tomato'} size="md" as="em">
            {t('VENDOR_UPLOAD_PAGE_DUE_DATE_PASSED_WARNING')}
          </Text>
        )}
      </Flex>
      <VStack alignItems={'flex-start'}>
        <Flex gap="2">
          <Text as="b">{t('VENDOR_UPLOAD_PAGE_SALES_RESPONSIBLE')}</Text>
          <Text>{RFQDetail?.salesResponsible}</Text>
        </Flex>
        <Flex gap="2">
          <Text as="b">{t('VENDOR_UPLOAD_PAGE_PROJECT_MANAGER')} </Text>
          <Text>{RFQDetail?.projectManager}</Text>
        </Flex>
        <Flex gap="2">
          <Text as="b">{t('VENDOR_UPLOAD_PAGE_PROCUREMENT_OFFICER')}</Text>
          <Text>{RFQDetail?.procurementOfficer}</Text>
        </Flex>
      </VStack>
    </Flex>
  )
}

export default VendorUploadQuotationPageHeader
